import useUserFacility from './userFacilityColumn';
import useUserRole from './userRoleColumn';

const columns = {
    useUserFacility, useUserRole
};
export default columns;

